import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/faqItems";
import SectionHeading from "@/components/feature/SectionHeading";

function FaqPreview() {
  const list = faqItems.slice(0, 4);
  const [openId, setOpenId] = useState<string>(list[0].id);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[2fr_1.2fr]">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="入坑前，先看看这些"
            desc="关于故事内容、更新节奏与阅读体验，这里整理了读者最常问的几个问题。"
          />
          <div className="divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
            {list.map((f) => {
              const isOpen = openId === f.id;
              return (
                <div key={f.id}>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? "" : f.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="text-sm font-semibold text-foreground-950 md:text-base">
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Link
            to="/faq"
            className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
          >
            查看更多常见问题 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <aside className="flex flex-col justify-between rounded-lg bg-secondary-100 p-6">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700">
              <i className="ri-mail-send-line"></i> 快速直达
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950">
              追更途中遇到问题？
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              无论是想了解结局走向、理清人物关系，还是想参与读者讨论，都可以从下面直达对应栏目。
            </p>
          </div>
          <div className="mt-6 flex flex-col gap-3">
            <Link to="/plot" className="flex items-center gap-3 rounded-md bg-background-50 p-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-primary-50">
              <i className="ri-film-line text-primary-600"></i> 剧情解析
            </Link>
            <Link to="/characters" className="flex items-center gap-3 rounded-md bg-background-50 p-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-primary-50">
              <i className="ri-team-line text-secondary-600"></i> 角色设定
            </Link>
            <Link to="/reviews" className="flex items-center gap-3 rounded-md bg-background-50 p-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-primary-50">
              <i className="ri-chat-3-line text-accent-600"></i> 读者评价
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default FaqPreview;